module.exports = __webpack_public_path__ + "static/media/everyday_digital.ef412e6a.png";